import type { TemplateMeta } from '../../types';
import { CalendarIcon } from './components/Icon';
import { getDefaultRange, getRangeForAnchor } from './dateRange';

export const plannerCalendarMeta: TemplateMeta = {
  name: 'Calendar',
  orientation: 'landscape',
  Icon: CalendarIcon,
  theme: 'block',
  eventListDisplayCustomLabel: 'Calendar',
  eventListDisplayFullLabel: null,
  eventListRangePicker: 'month-range',
  getDefaultRange,
  getRangeForAnchor,
  featureFlag: 'standalonePlannerPrintableEnabled',
};
